import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from '../../../redux';
import viewFolderStyles from './../viewfolders.module.scss';
// helpers
import { isMediaSizeMD, isMediaSizeMoreThanLG } from '../../../helpers/layout';
import { clearWhitespaces } from '../../../helpers/general';
// Config
import { ConfigContext } from '../../../providers';
import { Avatar } from '../../Avatar/Avatar';
import { createSenderIconUrl } from '../../../helpers/createSenderIconUrl';

class SenderItem extends React.Component<any> {
    private ident = `${clearWhitespaces(this.props.sender.name) + this.props.itemIndex}_level`;
    folderItemRef = React.createRef<HTMLDivElement>();

    public render() {
        const unreadCount = this.props.sender.count;
        const isActiveSender = this.props.sender.id == this.props.selectedSender?.id;
        return (
            <ConfigContext.Consumer>
                {(config): JSX.Element => (
                    <div
                        tabIndex={0}
                        role="button"
                        ref={this.folderItemRef}
                        className={`${
                            isActiveSender ? viewFolderStyles.selected : ''
                        } d-flex flex-row align-items-center col-lg-12 p-0`}
                        key={this.ident}
                        id={`folderItem${this.ident}`}
                        onClick={() => this.props.onActiveSenderClick(this.props.sender, this.props.itemIndex)}
                        onKeyPress={(e) =>
                            e.key === 'Enter' && this.props.onActiveSenderClick(this.props.sender, this.props.itemIndex)
                        }
                    >
                        {isMediaSizeMoreThanLG(this.props.mediaSize) || this.props.sidebarShown ? (
                            <>
                                <div
                                    id={`toggle${this.ident}`}
                                    className={[
                                        viewFolderStyles.toggleExpanderIconWrap,
                                        viewFolderStyles[`mlL${this.props.level}`],
                                        'd-flex align-items-center py-2',
                                    ].join(' ')}
                                />
                                <div
                                    className={generateLevelMinWidth(
                                        [
                                            viewFolderStyles.folderLine,
                                            'd-flex justify-content-between align-items-center flex-row',
                                        ].join(' '),
                                        this.props.level
                                    )}
                                >
                                    <div
                                        className={[
                                            'd-flex align-items-center w-100',
                                            isMediaSizeMD(this.props.mediaSize) && !this.props.sidebarShown
                                                ? 'justify-content-center w-100'
                                                : '',
                                        ].join(' ')}
                                    >
                                        <div
                                            className={[
                                                'd-flex align-items-start py-2',
                                                isMediaSizeMoreThanLG(this.props.mediaSize) || this.props.sidebarShown
                                                    ? 'mr-1'
                                                    : '',
                                            ].join(' ')}
                                        >
                                            <div style={{ height: '30px' }}>
                                                <Avatar
                                                    senderName={this.props.sender.name}
                                                    senderLogoUrl={createSenderIconUrl({
                                                        id: this.props.sender.cvrNumber,
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        {isMediaSizeMoreThanLG(this.props.mediaSize) || this.props.sidebarShown ? (
                                            <div
                                                id={`description${this.ident}`}
                                                className={generateLevelWidth(
                                                    [viewFolderStyles.folderText, 'align-items-start py-2 px-0'].join(
                                                        ' '
                                                    ),
                                                    this.props.level,
                                                    unreadCount
                                                )}
                                                style={{ color: config.colors.sidebar.folderNameColor }}
                                            >
                                                {this.props.sender.name}
                                            </div>
                                        ) : null}
                                    </div>
                                    {unreadCount > 0 ? (
                                        <div className={['mr-4', viewFolderStyles.unreadCount].join(' ')}>
                                            {`(${unreadCount})`}
                                        </div>
                                    ) : null}
                                </div>
                            </>
                        ) : (
                            <div className="d-flex align-items-center justify-content-center w-100 py-2">
                                <div style={{ height: '30px' }}>
                                    <Avatar
                                        senderName={this.props.sender.name}
                                        senderLogoUrl={createSenderIconUrl({
                                            id: this.props.sender.cvrNumber,
                                        })}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </ConfigContext.Consumer>
        );
    }
}

const generateLevelMinWidth = (className = '', level = 0): string => {
    const classNames = [];
    classNames.push(viewFolderStyles['mwL' + level]);

    if (className) classNames.push(className);

    return classNames.join(' ');
};

const generateLevelWidth = (className = '', level = 0, unreadCount: number): string => {
    const classNames = [];
    if (unreadCount > 0) {
        classNames.push(viewFolderStyles['wL' + level]);
    } else {
        classNames.push('w-75');
    }

    if (className) classNames.push(className);

    return classNames.join(' ');
};

const mapStateToProps = ({ mailbox, sidebar, appReadouts, sender }: IRootState) => {
    return {
        sidebarShown: sidebar.sidebarShown,
        mediaSize: appReadouts.mediaSize,
        searchValue: mailbox.searchValue,
        selectedSender: mailbox.selectedSender,
        senderLogos: sender.senderLogos,
    };
};

const reduxConnected = connect(mapStateToProps)(SenderItem);

export default reduxConnected;
